import type {
  ActiveShareLocationResponse,
  SharedLocationSession,
} from "@/features/share_location/types";
import { snakeToCamelCase } from "@/features/utils/utils";

export const mapSharedLocationSession = (data: any): SharedLocationSession => {
  const mappedData: any = {};
  Object.keys(data).forEach((key) => {
    mappedData[snakeToCamelCase(key)] = data[key];
  });

  if (Array.isArray(data.coordinates)) {
    mappedData.coordinates = {
      lat: data.coordinates[1],
      lng: data.coordinates[0],
    };
  }

  return mappedData as SharedLocationSession;
};

export const mapActiveShareLocationResponse = (
  data: any,
): ActiveShareLocationResponse => {
  const mappedData: ActiveShareLocationResponse = {
    expirationTimestamp: data.expiration_timestamp || null,
    sessionId: data.session_id || null,
  };

  return mappedData;
};
